<div>
  <app-titlebar #titlebar></app-titlebar>
</div>
<mdq-search [apiBaseUrl]="backendUrl" [apiToken]="mdQueryToken()" />

